import React from 'react';
import { useExternalLink } from './ExternalLinkWarning';
import './GovernmentMarquee.css';

const GovernmentMarquee = () => {
  const { showWarning } = useExternalLink();

  // Handle external link clicks
  const handleExternalLink = (e, url) => {
    e.preventDefault();
    showWarning(url);
  };

  const governmentLinks = [
    {
      name: 'Mahakamgar',
      image: '/images/homepage-marquee/mahakamgar.png',
      url: 'https://mahakamgar.maharashtra.gov.in/'
    },
    {
      name: 'VVGNLI',
      image: '/images/homepage-marquee/vvgnli.png',
      url: 'https://vvgnli.gov.in/'
    },
    {
      name: 'Maharashtra Government',
      image: '/images/homepage-marquee/mahagov.png',
      url: 'https://maharashtra.gov.in/'
    },
    {
      name: 'India Government',
      image: '/images/homepage-marquee/indiagov.png',
      url: 'https://www.india.gov.in/'
    },
    {
      name: 'Mahadish',
      image: '/images/homepage-marquee/mahadish.png',
      url: 'https://mahadish.in/'
    },
    {
      name: 'Mahaboiler',
      image: '/images/homepage-marquee/mahaboiler.png',
      url: 'https://www.mahaboiler.in/boiler/home.html'
    },
    {
      name: 'MSSSB',
      image: '/images/homepage-marquee/msssb.png',
      url: 'https://www.msssb.in/'
    },
    {
      name: 'Mahabocw',
      image: '/images/homepage-marquee/mahabocw.png',
      url: 'https://mlwb.in/'
    },
    {
      name: 'Aaple Sarkar',
      image: '/images/homepage-marquee/applesarkar.png',
      url: 'https://aaplesarkar.mahaonline.gov.in/'
    }
  ];

  return (
    <div className="government-marquee-container">
      <div className="government-marquee">
        <div className="marquee-content">
          {governmentLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="marquee-item"
              title={link.name}
              onClick={(e) => handleExternalLink(e, link.url)}
            >
              <img
                src={link.image}
                alt={link.name}
                className="marquee-image"
              />
            </a>
          ))}
        </div>
        {/* Duplicate content for seamless loop */}
        <div className="marquee-content">
          {governmentLinks.map((link, index) => (
            <a
              key={`duplicate-${index}`}
              href={link.url}
              className="marquee-item"
              title={link.name}
              onClick={(e) => handleExternalLink(e, link.url)}
            >
              <img
                src={link.image}
                alt={link.name}
                className="marquee-image"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GovernmentMarquee;
